import { updateQueryCache } from 'api/urql/helpers/mutation';
import { query as getImportedDrafts } from 'components/pages/import/queries/getImportedDrafts';
import { query as paginatedDraftJobRequests } from 'components/pages/jobRequestDrafts/queries/paginatedDraftJobRequests';

export const copyJobRequest = (results, args, cache, info) => {
  // handlers go here
  updateQueryCache({
    fieldName: 'importedDrafts',
    query: getImportedDrafts,
    handleCacheUpdate: (data) => {
      if (data === null) {
        return null;
      }
      data.importedDrafts.edges.push({
        node: results.copyJobRequest.jobRequest,
        __typename: 'JobRequestEdge',
      });
      return data;
    },
  })(results, args, cache, info);

  updateQueryCache({
    fieldName: 'paginatedDraftJobRequests',
    query: paginatedDraftJobRequests,
    handleCacheUpdate: (data) => {
      if (data === null) {
        return null;
      }
      data.paginatedDraftJobRequests.edges.unshift({
        node: results.copyJobRequest.jobRequest,
        __typename: 'JobRequestEdge',
      });
      return data;
    },
  })(results, args, cache, info);
};
